<form [formGroup]="formGroup">
  <legend
    class="col-form-label"
    [innerText]="'ViewServiceInformation' | translate">
  </legend>
  <div class="row">
    <div dsCol [colOptions]="fo.fullCol">
      <app-bs-display
        key="trCitesPurposeFld"
        [valueText]="transaction.serviceTransaction.purpose | lookup:lang"
        [templateOptions]="fo.inputsTemplateOptions">
      </app-bs-display>
    </div>
    <div dsCol [colOptions]="fo.fullCol">
      <app-bs-display
        key="trCitesSpecialCasesFld"
        [valueText]="transaction.serviceTransaction.specialCases"
        [templateOptions]="fo.inputsTemplateOptions">
      </app-bs-display>
    </div>
    <div dsCol [colOptions]="fo.halfCol">
      <app-bs-display
        key="trCitesArrivalDateFld"
        [valueText]="transaction.serviceTransaction.arrivalDate | date:'dd/MM/yyyy'"
        [templateOptions]="fo.inputsTemplateOptions">
      </app-bs-display>
    </div>
    <div dsCol [colOptions]="fo.halfCol">
      <app-bs-display
        key="trImportEntryPortFld"
        [valueText]="transaction.serviceTransaction.entryPort | lookup:lang"
        [templateOptions]="fo.inputsTemplateOptions">
      </app-bs-display>
    </div>
    <div dsCol [colOptions]="fo.halfCol">
      <bs-ng-text
        formControlName="shippingBillNumber"
        identifier="shippingBillNumber"
        key="trCitesBillNumberFld"
        name="shippingBillNumber"
        maxlength="100"
        [templateOptions]="fo.inputsTemplateOptions">
      </bs-ng-text>
    </div>
    <div dsCol [colOptions]="fo.halfCol">
      <bs-ng-dropdown
        formControlName="shippingMethod"
        identifier="shippingMethod"
        key="trCitesShippingMethodFld"
        name="shippingMethod"
        [items]="lookups.shippingMethods"
        [bindLabel]="defaultLookupDisplayProperty"
        [templateOptions]="fo.inputsTemplateOptions">
      </bs-ng-dropdown>
    </div>
    <div dsCol [colOptions]="fo.halfCol">
      <bs-ng-text
        formControlName="shippingPolicy"
        identifier="shippingPolicy"
        key="trCitesShippingPolicyFld"
        name="shippingPolicy"
        maxlength="50"
        [templateOptions]="fo.inputsTemplateOptions">
      </bs-ng-text>
    </div>
    <div dsCol [colOptions]="fo.halfCol">
      <bs-ng-text
        formControlName="tanker"
        identifier="tanker"
        key="trCitesTankerFld"
        name="tanker"
        maxlength="50"
        [templateOptions]="fo.inputsTemplateOptions">
      </bs-ng-text>
    </div>
    <div dsCol [colOptions]="fo.halfCol">
      <bs-ng-text
        formControlName="exportingPortForRelease"
        identifier="exportingPortForRelease"
        key="trCitesExportingPortFld"
        name="exportingPortForRelease"
        maxlength="100"
        [templateOptions]="fo.inputsTemplateOptions">
      </bs-ng-text>
    </div>
    <div dsCol [colOptions]="fo.halfCol">
      <bs-ng-date
        formControlName="checkinDate"
        identifier="checkinDate"
        key="trCitesCheckinDateFld"
        name="checkinDate"
        [templateOptions]="fo.inputsTemplateOptions">
      </bs-ng-date>
    </div>
  </div>
</form>